import React from 'react';
import { makeStyles, Paper, } from '@material-ui/core';
import CustomerNoteCard from '../../../../components/CustomerNoteCard';
import { theme } from '../../../../theme/mui-theme';
import { transformCustomerNotes } from '@/api/transforms/customer';
import { CustomerNoteModel } from '@/models/customer';

const useStyles = makeStyles(() => ({
	paper: {
		padding: '15px',
		marginBottom: '20px',
	},
	noDataFoundPaper: {
		height: '200px',
		textAlign: 'center',
		paddingTop: '50px',
		paddingBottom: '50px',
		position: 'relative',
	},
	noDataFoundContent: {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		width: '100%',
	},

	notes: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: theme.spacing(2)
	}
}));

interface Props {
	customerNotes?: CustomerNoteModel[]
}

export const Notes = ({ customerNotes }: Props) => {
	const classes = useStyles();

	if (customerNotes === undefined || customerNotes.length === 0) {
		return (
			<Paper data-id="noDataFound" className={[classes.paper, classes.noDataFoundPaper].join(' ')}>
				<div className={classes.noDataFoundContent}>
					<p>No note for this customer was found!</p>
				</div>
			</Paper>
		);
	}

	// @ts-ignore will be fixed after API updates
	const noteModels = transformCustomerNotes(customerNotes);

	return (
		<>
			<div data-id="notes" className={classes.notes}>
				{noteModels.map(note => {
					return <CustomerNoteCard key={note.id} note={note} />;
				})}
			</div>
		</>
	);
};
